import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Icon from 'antd/lib/icon';
import Table from 'antd/lib/table';
import { ResponsiveTable, OpenFileLink } from '../../../../common/components/data-display';
import { contractStatus, contractStatusT, contractType } from '../../../../common/enums';
import { getContractType, formatDateTime } from '../../../../common/utils/helpers';

const Column = Table.Column;

const ContractsList = ({ documents, t, token, accountRole }) => {
  let url = window.location.href.split('#')

  let isInAdmin = false

  if(typeof url[1] !== 'undefined' && (url[1].indexOf('/admin') !== -1)) {
    isInAdmin = true
  }

  return documents.length > 0 ? (
    <section className="documents-list">
      <ResponsiveTable dataSource={documents} rowKey={doc => doc.id}>
        {isInAdmin && (
          <Column
            title={t('Číslo zmluvy')}
            dataIndex="contractNumber"
            key="contractNumber"
            render={(contractNumber, record) =>
              record.type === contractType.MANDATE ? record.id : contractNumber
            }
          />
        )}
        <Column
          title={t('Typ zmluvy')}
          dataIndex="type"
          key="type"
          render={type => getContractType(type, accountRole)}
        />
        <Column
          title={t('Stav zmluvy')}
          dataIndex="status"
          key="status"
          render={status => contractStatusT[status]}
        />

        <Column
          title={t('Dátum')}
          dataIndex="updatedAt"
          key="updatedAt"
          render={updatedAt => formatDateTime(updatedAt)}
        />

        <Column
          title=""
          dataIndex="fileId"
          key="download"
          render={(fileId, doc) =>
            doc.status === contractStatus.PENDING_CONFIRMATION ||
              doc.status === contractStatus.CONFIRMED ? (
                <OpenFileLink href={`${process.env.REACT_APP_API_URL}/file/${fileId}?token=${token}`}>
                  {t('Prečítať zmluvu')}
                </OpenFileLink>
              ) : (
                t('Čaká sa na vygenerovanie zmluvy')
              )
          }
        />
      </ResponsiveTable>
    </section>
  ) : (
      <p>
        <Icon type="info-circle-o" /> {t('Neexistujú žiadne zmluvy.')}
      </p>
    );
};

ContractsList.propTypes = {
  documents: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  accountRole: PropTypes.string.isRequired,
};

export default translate()(ContractsList);



// WEBPACK FOOTER //
// ./src/features/account-management/components/contracts/ContractsList.js